import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _class, _descriptor, _descriptor2, _descriptor3, _class2, _temp;

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { RouteHttpVerb } from "../../factory";
import { observable, computed, set, flow, runInAction } from "mobx";
var ClientModel = (_class = (_temp = _class2 = /*#__PURE__*/function () {
  function ClientModel(collection) {
    var _this = this;

    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ClientModel);

    _initializerDefineProperty(this, "data", _descriptor, this);

    _initializerDefineProperty(this, "collection", _descriptor2, this);

    _initializerDefineProperty(this, "busy", _descriptor3, this);

    this.annotated = void 0;
    this.persist = flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var _this$annotated, _this$annotated$creat, path, method, namespace, response;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.annotated.create) {
                _context.next = 2;
                break;
              }

              throw new Error("There is no persist method allowed");

            case 2:
              this.busy = true;
              _context.prev = 3;
              _this$annotated = this.annotated, _this$annotated$creat = _this$annotated.create, path = _this$annotated$creat.path, method = _this$annotated$creat.method, namespace = _this$annotated.namespace;
              _context.next = 7;
              return this.annotated.request({
                location: {
                  path: path,
                  method: method || RouteHttpVerb.POST,
                  namespace: namespace
                },
                request: this.transformDataForPersist(),
                params: params || {}
              });

            case 7:
              response = _context.sent;
              this.fromResponse(response);
              this.collection.entries.set(this.key, this);
              this.afterPersist();
              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](3);
              console.log(_context.t0);
              throw _context.t0;

            case 17:
              _context.prev = 17;
              this.busy = false;
              return _context.finish(17);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[3, 13, 17, 20]]);
    }));
    this.patch = flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
      var _this$annotated2, _this$annotated2$patc, path, method, namespace, response;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (this.annotated.patch) {
                _context2.next = 2;
                break;
              }

              throw new Error("There is no patch method allowed");

            case 2:
              this.busy = true;
              _context2.prev = 3;
              _this$annotated2 = this.annotated, _this$annotated2$patc = _this$annotated2.patch, path = _this$annotated2$patc.path, method = _this$annotated2$patc.method, namespace = _this$annotated2.namespace;
              _context2.next = 7;
              return this.annotated.request({
                location: {
                  path: path,
                  method: method || RouteHttpVerb.PATCH,
                  namespace: namespace
                },
                request: this.transformDataForPatch(),
                params: _objectSpread(_objectSpread({}, _defineProperty({}, this.annotated.keyId, this.key)), params || {})
              });

            case 7:
              response = _context2.sent;
              this.fromResponse(response);
              this.afterPatch();
              _context2.next = 16;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](3);
              console.log(_context2.t0);
              throw _context2.t0;

            case 16:
              _context2.prev = 16;
              this.busy = false;
              return _context2.finish(16);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[3, 12, 16, 19]]);
    }));
    this.delete = flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
      var _this$annotated3, _this$annotated3$dele, path, method, namespace, response;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (this.annotated.delete) {
                _context3.next = 2;
                break;
              }

              throw new Error("There is no delete method allowed");

            case 2:
              this.busy = true;
              _context3.prev = 3;
              _this$annotated3 = this.annotated, _this$annotated3$dele = _this$annotated3.delete, path = _this$annotated3$dele.path, method = _this$annotated3$dele.method, namespace = _this$annotated3.namespace;
              _context3.next = 7;
              return this.annotated.request({
                location: {
                  path: path,
                  method: method || RouteHttpVerb.DELETE,
                  namespace: namespace
                },
                params: _objectSpread(_objectSpread({}, _defineProperty({}, this.annotated.keyId, this.key)), params || {})
              });

            case 7:
              response = _context3.sent;
              this.collection.entries.delete(this.key);
              this.afterDelete();
              return _context3.abrupt("return", response);

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](3);
              console.log(_context3.t0);
              throw _context3.t0;

            case 17:
              _context3.prev = 17;
              this.busy = false;
              return _context3.finish(17);

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[3, 13, 17, 20]]);
    }));
    setTimeout(function () {
      if (!_this.annotated) {
        console.error("You have not used the @ClientModel.annotate annoation together with this class!");
      }
    }, 0);
    runInAction(function () {
      _this.collection = collection;
      _this.data = data;
    });
  }

  _createClass(ClientModel, [{
    key: "key",
    get: function get() {
      var _this$data;

      return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data[this.annotated.keyId];
    }
  }, {
    key: "fromResponse",
    value: function fromResponse(response) {
      set(this.data, response);
      return this;
    } // eslint-disable-next-line @typescript-eslint/member-ordering

  }, {
    key: "transformDataForPersist",
    value:
    /**
     * Transform the class-hold data to POSTable data. This can be useful if e. g.
     * one property differs from the response property schema.
     */
    function transformDataForPersist() {
      return this.data;
    }
    /**
     * Create your conditionals here and return only changed values.
     */

  }, {
    key: "transformDataForPatch",
    value: function transformDataForPatch() {
      throw new Error("If you want to use patch method, you need to implement transformDataForPatch!");
    }
  }, {
    key: "afterPersist",
    value: function afterPersist() {// Silence is golden.
    }
  }, {
    key: "afterPatch",
    value: function afterPatch() {// Silence is golden.
    }
  }, {
    key: "afterDelete",
    value: function afterDelete() {// Silence is golden.
    }
  }]);

  return ClientModel;
}(), _class2.annotate = function (annotate) {
  return function (constructor) {
    return /*#__PURE__*/function (_constructor) {
      _inherits(_class4, _constructor);

      var _super = _createSuper(_class4);

      function _class4() {
        var _this2;

        _classCallCheck(this, _class4);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this2 = _super.call.apply(_super, [this].concat(args));
        _this2.annotated = annotate;
        return _this2;
      }

      return _class4;
    }(constructor);
  };
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "collection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "busy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "key", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "key"), _class.prototype)), _class);
export { ClientModel };